// CropperModal.tsx
import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Dialog, DialogContent, DialogActions, Button, Slider } from '@mui/material';
import getCroppedImg from './cropImage'; // util function you'll create

const CropperModal = ({ imageSrc, open, onClose, onCropComplete }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropCompleteInternal = useCallback((_, areaPixels) => {
        setCroppedAreaPixels(areaPixels);
    }, []);

    const handleCrop = async () => {
        const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
        onCropComplete(croppedImage);
        onClose();
    };

    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogContent>
                <div style={{ position: 'relative', width: '100%', height: 400 }}>
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={21 / 9}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={onCropCompleteInternal}
                    />
                </div>
                <Slider value={zoom} min={1} max={3} step={0.1} onChange={(_, z) => setZoom(z)} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>გაუქმება</Button>
                <Button onClick={handleCrop}>დამახსოვრება</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CropperModal;
